import { ValidatorFn } from "./models/ValidatorFn";

export const validateDomainCase: ValidatorFn = (domain: string): boolean => {
    // onlylowerCase alphanumeric    
    const re = /^([a-z0-9]{1}[a-z0-9-_]{1,62})*$/g;
    return re.test(domain.trim());
}